/** プライバシーポリシー（日本語本文は本ファイルで管理） */
export const privacyTitle = '個人情報取扱規定';

export const privacyBody =
`第1章 総則
（目的）
第１条 本規則は、株式会社Japan DX（以下、「当社」という）が本会議における個人情報等の取り扱いの基本事項について定めるもので、本規則を遵守のうえ、個人情報等の取り扱いについて、細則を定めることが出来る。ただし、本会議従業員の個人情報の取り扱いについては別に定めるところによる。
（定義）
第２条 規程における用語の定義は次のとおりとする。
（１）個人情報
生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等 により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）をいう。
（２）個人情報データベース等
個人情報を含む情報の集合物であって、次に掲げるものをいう。
イ. 特定の個人情報を電子計算機を用いて検索できるように体系的に構成したもの
ロ. イに掲げるもののほか、当該情報の集合物に含まれる個人情報を一定の規則に従って整理することにより特定の個人情報を容易に検索することができるよう体系的に構成した情報の集合物であって、目次、索引その他検索を容易にするためのものを有するものをいう。
（３）個人データ
個人情報データベース等を構成する個人情報をいう。
（４） 保有個人データ
本会議が、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止を行うことのできる権限を有する個人データの全て、次に掲げるもの以外のものをいう。
イ. 当該個人データの存否が明らかになることにより公益その他の利益が害されるもの
ロ. 6ヶ月以内に消去することとなるもの
（５） 本人
個人情報によって識別される特定の個人をいう。
（個人情報保護統括管理者等）
第３条 （１） 個人情報の保護のための措置に関する業務を統括する者として、個人情報保護統括管理者を置くものとし、個人情報保護統括管理者がその任にあたる。
第2章 個人情報
（取得の原則）
第４条 （１） 個人情報は、事業・業務に必要な範囲内で取得するものとし、あらかじめ利用目的を特定し、その目的の達成に必要な限度において行う。
（２） 原则として次の内容を含む個人情報の取得、利用又は提供を行わない。
1. 思想、信条及び宗教に関する事項
2. 人種、民族、門地、本籍地(都道府県を除く)、その他社会的差別の原因となる事項
（適正な取得）
第５条 偽りその他不正の手段により個人情報を取得してはならない。
（利用目的の公表又は通知）
第６条 （１） 個人情報取得に当たり、原則として次の事項をホームページ、機関紙等で公表する。
1. 利用目的
2. 個人データの第三者提供に関する事項
3. 個人データの共同利用に関する事項
（２） 利用目的を公表していない場合は、個人情報の取得に際し、その利用目的を書面又は口頭により本人に通知する。ただし次の場合を除く。
1. 利用目的を本人に通知し、又は公表することにより本人又は第三者の生命、身体、財産その他の権利利益を害するおそれのある場合
2. 利用目的を本人に通知し、又は公表することにより本会議の権利又は正当な利益を害するおそれのある場合
3. 国の機関又は地方公共団体が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用目的を本人に通知し、又は公表することにより当該事務の遂行に支障を及ぼすおそれがあるとき
4. 取得の状況からみて利用目的があきらかであると認められる場合
（３） 第1項に規定する各号の制定及び改変については、軽微な修正を除き、個人情報保護統括責任者の承認を得るものとする。
第3章 個人データ
（正確性の確保）
第７条 個人データについては、正確かつ最新の内容に保つよう努める。
（保存期間）
第８条 個人データについては、利用目的の達成に必要な範囲内で保存期間を定めるよう努め、当該保存期間経過後又は利用目的を達成した後は、遅滞なくこれを消去するよう努める。
（安全管理措置）
第９条 （１） 個人データの漏洩、滅失又は毀損(以下「漏洩等」という)を防止するため、以下の措置を講ずる。
1. 技術的管理措置として、不正アクセスからの防御に努める。
2. 人的管理措置として、個人情報の漏洩等が発生しないよう従業員に周知徹底に努める。また、必要に応じて秘密保持契約を締結する。
（２） 従業員は、個人情報の漏洩等が発生しないよう未然防止に努めなければならない。
（委託先の監督）
第１０条 個人データの取り扱いを外部に委託する場合は、委託先と秘密保持に関する事項、再委託に関する事項及び前条で定める安全管理措置に関する事項について契約する。
（第三者提供の制限）
第１１条 （１） 個人データを第三者に提供する場合、あらかじめ書面又は口頭により明示的な本人の同意を得るものとする。ただし、次の場合を除く。
1. 法令に基づく場合
2. 人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
3. 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
4. 国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれのあるとき
5. 利用目的の達成に必要な範囲において个人データの取り扱いを委託する場合
6. 第６条第１項第２号により、個人情報保護法第２３条第２項が定める事項を公表しているとき
7. 第６条第１項第３号により、個人情報保護法第２３条第４項第３号が定める事項を公表しているとき
（２） 個人データを第三者に提供する場合、あらかじめ個人情報事務管理者に届け出のうえ、個人情報保護統括管理者の承認を得るものとする。ただし、前項第５号に該当する場合、前項第６号又は第７号に規定する措置を講じている場合、並びに緊急を要する場合を除く。
第4章 保有個人データ
（保有個人データに関する事項の公表等）
第１２条 （１） 本人から当該本人が識別される保有個人データの利用目的の通知を求められた場合は、遅滞なくこれを通知するものとする。ただし次の場合を除く。
1. 保有個人データの利用目的が明らかな場合
2. 第６条第２項第１号から第３号までに該当する場合
（２） 前項の規定により求められた保有個人データの利用目的を通知しない旨の決定をしたときは本 人に対し遅滞なく当該決定した旨を通知する。
（開示）
第１３条 （１） 本人から当該本人が識別される保有個人データの開示（当該本人が識別される保有個人データが存在しないときはその旨を知らせることを含む。以下同じ）を求められたときは、書面又は本人が同意した方法により、遅滞なく当該保有データを開示する。ただし、次の場合を除く。
1. 本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
2. 本会議業務の適正な実施に著しい支障を及ぼすおそれのある場合
3. 他の法令に違反することとなる場合
（２） 前項の規定より求められた保有個人データの 全部又は一部について開示しない旨の決定をしたときは本人に対し、遅滞なく当該決定した旨及び根拠となる条項を通知する。
（３） 他の法令の規定により、本人に対し第1項本文に規定する方法に相当する方法により当該本人が識別される保有個人データの全部又は一部を開示することとされている場合は、同項の規定は 適用しない。
（訂正等）
第１４条 （１） 本人から、当該本人が識別される保有個人データの内容が事実でないという理由によって当該保有個人データの内容の訂正、追加又は削除（以下「訂正等」という）を求められた場合には、利用目的の達成に必要な範囲内において、遅滞なく事実の確認等必要な調査を行い、その結果に基づき、当該保有個人データの内容の訂正等を行う。
（２） 前項により訂正等を行ったとき、又は行わない旨の決定をしたときは、本人に対し、遅滞なく、そ の旨(訂正等を行ったときは、その内容を含む)を通知する。
（利用停止等）
第１５条 （１） 本人から、個人情報保護法第１６条（利用目的による制限）又は第１７条（適正な取得）に違反するという理由で保有個人データの利用の停止や消去を求められた場合で、その求めに理由がある ことが判明したときは、必要な限度で、遅滞なく、当該保有データの利用停止等を行うか、これが 困難な場合は、本人の権利利益を保護するため必要なこれに代わるべき措置をとる。
（２） 本人から、個人情報保護法第２３条（第三者提供の制限）に違反するという理由で保有個人データの第三者への提供の停止を求められた場合で、その求めに理由があることが判明したときは、 必要な限度で、遅滞なく、当該保有データの第三者への提供を停止するか、これが困難な場合は、 本人の権利利益を保護するため必要なこれに代わるべき措置をとる。
（３） 前２項の各措置を行ったとき、又は行わない旨を決定したときは、遅滞なく、その旨を本人に通知する。
（理由の説明）
第１６条 第１２条第２項、第１３条第２項、第１４条第２項、前条第３項の規定により、本人から求められた措置の全部又は一部について、その措置をとらない旨を通知する場合又はその措置と異なる措置をとる旨を通知する場合は、本人に対し、その理由を説明するよう勤める。
第５章 漏洩等への対応
（漏洩等が発生した場合の対応）
第１７条 （１） 漏洩等の事実を把握した従業員はその事実を速やかに個人情報保護事務管理者に口頭で報告しなければならない。
（２） 個人情報保護事務管理者は、二次災害の防止、類似事案の発生回避等のため、事実関係を速やかに調査・確認するとともに、可能な限り事実関係等を公表するよう努めるものとする。また、事実関係の調査・確認に時間を要する場合にも二次災害の防止の観点から漏洩事実の公表等を行い社会的な信頼の回復に努める。
以上
`;
